import { useState, useEffect } from "react";
import { Timer } from "lucide-react";

export const GameCountdown = ({ broadcast }) => {
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    const calculateCountdown = () => {
      const gameTime = new Date(`${broadcast.scheduled_date}T${broadcast.scheduled_time || "00:00"}`);
      const now = new Date();
      const diff = gameTime - now;

      if (diff <= 0) {
        setExpired(true);
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      return {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((diff % (1000 * 60)) / 1000)
      };
    };

    const initial = calculateCountdown();
    setCountdown(initial);
    const interval = setInterval(() => setCountdown(calculateCountdown()), 1000);
    return () => clearInterval(interval);
  }, [broadcast.scheduled_date, broadcast.scheduled_time]);

  if (expired) return null;

  return (
    <div className="bg-zinc-900/50 border border-white/10 p-6">
      <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4 flex items-center gap-2 justify-center">
        <Timer className="w-4 h-4 text-orange-500" />
        Game Starts In
      </h3>
      <div className="grid grid-cols-4 gap-2">
        {[
          { value: countdown.days, label: 'Days' },
          { value: countdown.hours, label: 'Hours' },
          { value: countdown.minutes, label: 'Mins' },
          { value: countdown.seconds, label: 'Secs' }
        ].map((item, idx) => (
          <div key={idx} className="bg-zinc-800/50 p-3 flex flex-col items-center justify-center min-h-[80px]">
            <p className={`text-2xl md:text-3xl font-black leading-none ${idx === 3 ? 'text-orange-500' : 'text-white'}`}>
              {String(item.value).padStart(2, '0')}
            </p>
            <p className="text-zinc-500 text-[10px] uppercase mt-1 text-center">{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
